import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const tableHead = [
  "Sr.",
  "Template Name",
  "Template Category",
  "Template Status",
  "Actions",
];
const WhatsappTemplateTable = ({ data, currentPage, itemsPerPage, onView }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/watsapp-logs/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.templateName || "N/A"}</td>
                <td>{item?.templateCategory || "N/A"}</td>
                <td>{item?.templateStatus || "N/A"}</td>
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    // onClick={() => goToView(item.id)}
                    onClick={() => onView(item)}
                  >
                    <BsArrowRightShort className="me-1" />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default WhatsappTemplateTable;
